<div class="btns-container d-flex flex-column flex-md-row mt-2">
  <app-bookmark-button-container
    [fgOrEntity]="entity">
  </app-bookmark-button-container>
  <app-entity-options-button
    [entityType]="data.entityType"
    [resourceData]="resourceData">
  </app-entity-options-button>
</div>
